import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faTimes,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import {
  Filter,
  FilterTrigger,
  FilterTriggerInner,
  FilterOptions,
  Header,
  CloseButton,
  FilterOption,
  FilterTriggerWrapper,
} from "./styles/child-company-filter-styles";

interface ICompanyProps {
  id: string;
  name: string;
}

export interface IChildCompanyFilterProps {
  selectedCompany: ICompanyProps;
  currentCompany: ICompanyProps;
  selectableCompanies: Array<ICompanyProps>;
  setSelectedCompany: (company: ICompanyProps) => void;
  titleSuffix?: string;
}

interface IChildCompanyFilterState {
  filterActive: boolean;
}

class ChildCompanyFilter extends Component<
  IChildCompanyFilterProps,
  IChildCompanyFilterState
> {
  static propTypes = {
    selectedCompany: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    currentCompany: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    selectableCompanies: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    titleSuffix: PropTypes.string,
  };

  static defaultProps = {
    selectableCompanies: [],
    selectedCompany: {},
    titleSuffix: "",
  };

  state = { filterActive: false };

  toggleFilter = (): void => {
    const { filterActive } = this.state;

    this.setState(() => ({
      filterActive: !filterActive,
    }));
  };

  getCompanyName = (company: ICompanyProps) => {
    const { currentCompany } = this.props;
    const isCurrentCompany = company.id === currentCompany.id;

    return isCurrentCompany ? `${company.name} (All)` : company.name;
  };

  render(): ReactNode {
    const {
      selectedCompany,
      currentCompany,
      selectableCompanies,
      setSelectedCompany,
      titleSuffix,
    } = this.props;
    const { filterActive } = this.state;

    return (
      <Filter id="child-company-filter">
        <FilterTriggerWrapper>
          <FilterTrigger>
            <FilterTriggerInner onClick={() => this.toggleFilter()}>
              {`${
                this.getCompanyName(selectedCompany) || currentCompany.name
              } ${titleSuffix}`}
            </FilterTriggerInner>
            <FontAwesomeIcon
              icon={faChevronDown}
              onClick={() => this.toggleFilter()}
            />
          </FilterTrigger>
        </FilterTriggerWrapper>

        <FilterOptions id="child-company-filter-options" active={filterActive}>
          <Header>Companies</Header>
          <CloseButton onClick={() => this.toggleFilter()}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
          {selectableCompanies.map((selectableCompany) => (
            <FilterOption
              id={`filter-${selectableCompany.name}`}
              key={selectableCompany.name}
              onClick={() => {
                setSelectedCompany(selectableCompany);
                this.toggleFilter();
              }}
            >
              {this.getCompanyName(selectableCompany)}
              {selectableCompany.name === selectedCompany.name && (
                <FontAwesomeIcon icon={faCheck} />
              )}
            </FilterOption>
          ))}
        </FilterOptions>
      </Filter>
    );
  }
}

export default ChildCompanyFilter;
